import { useAppNavigate } from './useAppNavigate';

export function useNavigate() {
  return useAppNavigate({ interceptBareTabKey: false });
}

export default useNavigate;
